import { render, staticRenderFns } from "./TeamMobileCard.vue?vue&type=template&id=485e3410&scoped=true&"
import script from "./TeamMobileCard.vue?vue&type=script&lang=js&"
export * from "./TeamMobileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e3410",
  null
  
)

export default component.exports